import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IotDevicesSection } from './iot-devices-section.component';

@NgModule({
  declarations: [
    IotDevicesSection
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    IotDevicesSection
  ]
})
export class IotDevicesSectionModule { }
